<template>
  <el-drawer
    :title="title"
    :before-close="handleClose"
    :visible.sync="dialog"
    direction="rtl"
    custom-class="demo-drawer"
    ref="drawer"
  >
    <div class="demo-drawer__content">
      <el-form :model="form" v-bind="$attrs" ref="form" :rules="rules">
        <el-form-item
          v-for="(item, i) in formItems"
          :key="i"
          :label="item.label"
          :label-width="formLabelWidth"
          :prop="item.value"
        >
          <template v-if="item.type === 'radio'">
            <el-radio-group v-model="form[item.value]">
              <el-radio-button v-for="item in item.options" :key="item.label" :label="item.value">{{ item.label }}</el-radio-button>
            </el-radio-group>
          </template>
          <template v-if="item.type === 'select'">
            <el-select clearable v-model="form[item.value]">
              <el-option
                v-for="(item, index) in item.options"
                :key="index"
                v-bind="item"
              >
              </el-option>
            </el-select>
          </template>
          <template v-if="item.type === 'textarea'">
            <el-input
              type="textarea"
              placeholder="请输入..."
              v-model="form[item.value]"
            />
          </template>
          <template v-if="item.type === 'input'">
            <el-input
              type="input"
              placeholder="请输入..."
              v-model.trim="form[item.value]"
            />
          </template>
          <template v-if="item.type === 'number'">
            <el-input
              type="number"
              v-model="form[item.value]"
              min="0"
              max="5"
              placeholder="请输入..."
              @input="handleDecimalInput(item.value)"
            />
            <el-rate
              v-model="form[item.value]"
              disabled
              :max="5"
              show-score
              text-color="#ff9900"
              style="margin-top: 10px"
              score-template="{value}"
            >
            </el-rate>
          </template>
          <template v-if="item.type === 'upload'">
            <!-- 上传图片 -->
            <el-upload
              action
              class="avatar-uploader"
              accept="image/jpeg"
              :show-file-list="false"
              :data="item"
              :http-request="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <img
                v-if="form[item.value] || imageUrl"
                :src="form[item.value] || imageUrl"
                class="avatar"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon" />
            </el-upload>
            <i v-if="form[item.value] || imageUrl" class="el-icon-delete" @click="deleteImage(item.value)"></i>
          </template>
          <template v-if="item.type === 'video'">
            <el-upload
              class="upload-demo"
              :data="item"
              action
              drag
              accept="video/*"
              :http-request="customUpload"
            >
              <video 
                controls 
                v-if="form[item.value] || videoUrl" 
                :src="form[item.value] || videoUrl" 
                @click.stop 
                class="video-element" 
              />
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将视频拖到此处，或<em>点击上传</em>
              </div>
              <!-- <div class="el-upload__tip" slot="tip">只能视频文件</div> -->
            </el-upload>

            <!-- 上传进度条 -->
            <el-progress
              v-if="uploading"
              :percentage="uploadProgress"
              :stroke-width="12"
              style="margin-top: 10px"
            />

            <i v-if="form[item.value] || imageUrl" class="el-icon-delete" @click="deleteVideo(item.value)"></i>
          </template>
        </el-form-item>
      </el-form>

      <div class="demo-drawer__footer">
        <el-button @click="cancelForm">取 消</el-button>
        <el-button type="primary" @click="submitForm()" :loading="loading">{{
          loading ? "提交中 ..." : "确 定"
        }}</el-button>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import { isNumber, isEmpty } from "lodash";
import { uploadImage, uploadVideo } from "@/api/uploading";
import request from "@/utils/request";

export default {
  props: {
    title: "",
    form: {},
    formItems: [],
    type: "",
  },
  data() {
    return {
      dialog: false,
      formLabelWidth: "70px",
      loading: false,
      imageUrl: "",
      videoUrl: "",

      uploading: false, // 是否正在上传
      uploadProgress: 0, // 上传进度
      rules: {}
    };
  },
  created() {
    // 动态生成非空校验规则
    this.rules = this.generateRequiredRules(this.formItems);
  },
  methods: {
    // 校验规则
    generateRequiredRules(formItems) {
      const rules = {};
      formItems.forEach(item => {
        rules[item.value] = [
          { required: item.required, message: `${item.label}不能为空`, trigger: 'change' }
        ];
      });
      console.log(rules);
      return rules;
    },
    handleDecimalInput(value) {
      // 获取当前输入的值
      let inputValue = this.form[value];

      // 使用正则表达式确保只保留最多1位小数
      if (inputValue) {
        // 保留小数点后一位，如果有多个小数点或超过1位小数，则裁剪
        inputValue = inputValue.replace(/^(\d+(\.\d{0,1})?).*$/, "\$1");
      }

      // 转换为数字类型，进行范围判断
      let numericValue = parseFloat(inputValue);

      // 如果是有效数字，并且在0到10之间
      if (!isNaN(numericValue)) {
        if (numericValue < 0) {
          numericValue = 0; // 小于0时设置为0
        } else if (numericValue > 5) {
          numericValue = 5; // 大于5时设置为5
        }
      } else {
        numericValue = ""; // 如果不是有效数字，则清空输入
      }

      // 更新表单数据
      this.form[value] = numericValue;
    },
    /**
     * 过滤表单对象,空数组也过滤，只取已定义的
     * @param values 要过滤的对象
     */
    filterObject(values) {
      const r = {};
      Object.keys(values).forEach((k) => {
        // 数字不过滤
        if (isNumber(values[k]) || !isEmpty(values[k])) {
          r[k] = values[k];
        }
      });
      return r;
    },
    submitForm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.imageUrl = ""
          this.videoUrl = ""
          this.$emit("submit", { ...this.filterObject(this.form) }, this.type);
          this.dialog = false;
        } else {
          return false;
        }
      });
    },
    init() {
      this.dialog = true;
    },
    handleClose() {
      if(Object.keys(this.form).length > 0) {
        this.$confirm("有未提交内容，确定关闭吗？")
        .then((_) => {
          // this.submitForm();
          this.dialog = false;
        })
        .catch((_) => {});
      } else {
        this.dialog = false;
      }
    },
    cancelForm() {
      this.$refs['form'].resetFields();
      this.dialog = false;
    },
    // 上传图片
    handleAvatarSuccess(file) {
      const key = file.data.value;
      const formData = new FormData();
      formData.append("img", file.file);

      uploadImage(formData).then((res) => {
        this.form[key] = res.data;
        this.imageUrl = res.data;
        console.log(this.form[key]);
      });
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    // 上传视频
    customUpload(file) {
      const key = file.data.value;
      const formData = new FormData();
      formData.append("file", file.file);
      this.uploading = true; // 开始上传
      this.uploadStatus = null;

      request.post("/sport-manage/classDetail/video/upload", formData, {
          onUploadProgress: (progressEvent) => {
            const percent = Math.round(
              (progressEvent.loaded / progressEvent.total) * 100
            );
            this.uploadProgress = percent;
          },
        })
        .then((res) => {
          this.$message.success("上传成功！");
          this.form[key] = res.data;
          this.videoUrl = res.data;
        })
        .catch((error) => {
          this.$message.error("上传失败！");
        })
        .finally(() => {
          this.uploading = false;
        });
    },
    // 删除图片
    deleteImage(key)  {
      console.log(key);
      this.form[key] = "";
      this.imageUrl = "";
    },
    // 删除视频
    deleteVideo(key) {
      console.log(key);
      this.form[key] = "";
      this.videoUrl = "";
      this.$forceUpdate(); // 强制更新视图
    },
  },
};
</script>

<style lang="scss" scoped>
.demo-drawer__content {
  height: 100%;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.demo-drawer__footer {
  display: flex;
  padding: 30px 0;
  .el-button {
    flex: 1;
  }
}

.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100%;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 100%;
  height: 100%;
  display: block;
}

.video-element {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.el-icon-delete {
  float: right;
  padding: 10px;
  font-size: 18px;
  cursor: pointer;
}

/* 使用 /deep/ 或 ::v-deep 穿透 Scoped CSS */
/deep/ .el-upload {
  width: 100%;
  height: 100%;
  display: block;
}

/deep/ .el-upload-dragger {
  width: 100%;
}

/deep/ .el-form-item__label {
  width: 100px !important;
}

/deep/ .el-form-item {
  display: flex;
  // align-items: center;
  justify-content: left;
}

/deep/ .el-form-item__content {
  width: 100%;
  margin-left: 0 !important;
}
</style>
